import { all } from 'redux-saga/effects';
import summarySaga from 'features/summary/sagas';
import purchaseOrderDetailSaga from 'features/purchase-order-detail/sagas';
import productsSaga from 'features/products/sagas';
import globalSaga from './global/sagas';

export default function* rootSaga() {
  yield all([globalSaga(), summarySaga(), purchaseOrderDetailSaga(), productsSaga()]);
}
